import { FormFieldTypes } from 'common/enums';
import { CrmName } from 'components/aufgaben-component/task.prop';
import { useEffect, useMemo } from 'react';
import { errorMessages } from 'utils/error-messages';
import { convertFilesForField } from '../../edit-task/use-edit-task';
import { useOverlay } from 'hooks';
import { editTask } from 'components/aufgaben-component/utils';
import { AnyObject } from 'chart.js/dist/types/basic';
import { getRequestFormData } from 'utils/get-response-data';
import { allFieldsCreateTask } from '../formFields';
import { UseEditUplaodDocumentExecutorTaskProps } from './edit-upload-docuument-executor-task.types';
import { useDispatch } from 'react-redux';
import { setSnakbar } from 'actions/app_action';
import { isEmpty } from 'lodash';

export const useEditUplaodDocumentExecutorTask = ({
  reactHookFormData,
  files,
  taskId,
  refresh,
  onCancel
}: UseEditUplaodDocumentExecutorTaskProps) => {
  const [showOverlay, hideOverlay] = useOverlay();
  const {
    setValue,
    handleSubmit,
    watch,
    formState: { errors }
  } = reactHookFormData;
  const dispatch = useDispatch();
  const existingFiles = watch(CrmName.Files);

  const formFields = useMemo(() => {
    return [
      {
        name: CrmName.Description,
        type: FormFieldTypes.TextArea,
        defaultValue: '',
        label: 'Hinweis',
        textAreaProps: {
          maxHeight: 400,
          minRows: 4
        },
        validation: {
          maxLength: { value: 254, message: errorMessages.getMaxTextLength(254) }
        }
      },
      {
        name: CrmName.Files,
        type: FormFieldTypes.File,
        defaultValue: [],
        validation: { required: errorMessages.fileRequired },
        dropzoneOptions: {
          maxFiles: 6,
          multiple: true,
          maxSize: 1024 * 1024 * 10
        }
      }
    ];
  }, []);

  const onSubmit = () => {
    handleSubmit(async data => {
      showOverlay();

      const existingFilesIds = data.files.filter((file: AnyObject) => file.id).map((file: AnyObject) => file.id);
      const formData = new FormData();

      formData.append('FilesComment', data.description);
      formData.append('id', taskId);
      formData.append('existingFiles', JSON.stringify(existingFilesIds));

      if (data.files) {
        data.files
          .filter((file: AnyObject) => !file.id)
          .forEach((file: File) => {
            formData.append('newfiles', file);
          });
      }

      editTask(formData)
        .then(response => {
          refresh();
          onCancel();
          dispatch(
            setSnakbar({
              isOpen: true,
              message: response.data.isSuccess
                ? 'Die Aufgabe wurde erfolgreich aktualisiert.'
                : 'Fehler, die Aufgabe wurde nicht geändert.',
              type: response.data.level.toLowerCase()
            })
          );
        })
        .catch(e => {
          console.log(e);
        })
        .finally(() => {
          hideOverlay();
        });
    })();
  };

  useEffect(() => {
    setValue(CrmName.Files, convertFilesForField(files));
  }, [files]);

  return { formFields, sumbitButtonDisabled: !isEmpty(errors), onSubmit };
};
